// src/utils/codeUtils.js

export function convertReadmeMarkdownLink(text) {
    return text.replace(/\[([^\]]+)\]\(([^)]+)\)/g, (match, p1, p2) => {
        if (p2.endsWith('/readme.md')) {
            p2 = '/component-library/' + p2.replace('/readme.md', '').replace('../', '');
        }
        return `<a href="${p2}">${p1}</a>`;
    });
}
